export const report_zhCN = {
  'report.retail.c01.lbl01': `VIP卡号`,
  'report.retail.c01.lbl02': `性别`,
  'report.retail.c01.lbl03': `年龄`,
  'report.retail.c01.lbl04': `会员等级`,
  'report.retail.c01.lbl05': `累计积分`,
  'report.retail.c01.lbl06': `累计总消费金额`,
  'report.retail.c01.lbl07': `开卡店仓`,
  'report.retail.c01.lbl08': `消费店仓`,
  'report.retail.c01.lbl09': `开卡日期`,
  'report.retail.c01.lbl10': `操作`,
  'report.retail.detail.n01.lbl01': `基本资料`,
  'report.retail.detail.n01.lbl02': `VIP卡号`,
  'report.retail.detail.n01.lbl03': `性别`,
  'report.retail.detail.n01.lbl04': `年龄`,
  'report.retail.detail.n01.lbl05': `会员等级`,
  'report.retail.detail.n01.lbl06': `累计积分`,
  'report.retail.detail.n01.lbl07': `累计消费总金额`,
  'report.retail.detail.n01.lbl08': `开卡店仓`,
  'report.retail.detail.n01.lbl09': `消费店仓`,
  'report.retail.detail.n01.lbl10': `加入日期`,
  'report.retail.detail.n01.lbl11': `生日月份`,
  'report.retail.detail.n01.lbl12': `有效期`,
  'report.retail.detail.n01.lbl13': `开卡日期`,
  'report.retail.detail.n02.lbl01': `会员详情`,
  'report.retail.detail.n02.lbl02': `订单记录`,
  'report.retail.detail.n02.lbl03': `兑换记录`,
  'report.retail.detail.n02.lbl04': `导购通标签`,
  'report.retail.detail.c01.lbl01': `零售单类型`,
  'report.retail.detail.c01.lbl02': `单据编号`,
  'report.retail.detail.c01.lbl03': `单据年份`,
  'report.retail.detail.c01.lbl04': `单据月份`,
  'report.retail.detail.c01.lbl05': `单据日期`,
  'report.retail.detail.c01.lbl06': `商品.类别.属性描述`,
  'report.retail.detail.c01.lbl07': `中国季节`,
  'report.retail.detail.c01.lbl08': `产品大类`,
  'report.retail.detail.c01.lbl09': `产品性别`,
  'report.retail.detail.c01.lbl10': `款式`,
  'report.retail.detail.c01.lbl11': `品名`,
  'report.retail.detail.c01.lbl12': `颜色`,
  'report.retail.detail.c01.lbl13': `货号`,
  'report.retail.detail.c01.lbl14': `尺码`,
  'report.retail.detail.c01.lbl15': `数量`,
  'report.retail.detail.c01.lbl16': `吊牌金额`,
  'report.retail.detail.c01.lbl17': `成交金额`,
  'report.retail.detail.c01.lbl18': `折扣率`,
  'report.retail.detail.c02.lbl01': `兑换日期`,
  'report.retail.detail.c02.lbl02': `消耗积分`,
  'report.retail.detail.c02.lbl03': `兑换内容`,
  'report.newpurchased.n01.lbl01': `数据截止时间`,
  'report.newpurchased.n01.lbl02': `凌晨`,
  'report.newpurchased.n02.lbl01': `1`,
  'report.newpurchased.n02.txt01': `该报表显示各市场今年的新增购买会员指标，各市场到T+1（当前时间的前一天）的实际新增购买会员数。`,
  'report.newpurchased.n02.txt02': `达成率 = 实际新增购买会员数/指标，当指标为0时，达成率显示为100%。`,
  'report.newpurchased.n02.lbl03': `2`,
  'report.newpurchased.n02.txt04': `周预测与实际趋势图中，数据按周统计，周数与outlook的周数保持一致，当今年第一周属于去年的周时，归为第0周。`,
  'report.newpurchased.n02.lbl05': `3`,
  'report.newpurchased.n02.txt06': `表头中指标 ! 的可查看指标的定义。`,
  'report.newpurchased.c01.lbl01': `市场`,
  'report.newpurchased.c01.lbl02': `指标`,
  'report.newpurchased.c01.lbl03': `会员数`,
  'report.newpurchased.c01.tip04': `2019年起注册且今年首购的会员数`,
  'report.newpurchased.c01.lbl05': `达成率`,
  'report.newpurchased.c01.tip06': `会员数/指标*100%，当指标为0时，达成率显示为100%`,
  'report.newpurchased.c02.lbl01': `周预测与实际趋势图`,
  'report.newpurchased.c02.lbl02': `预测`,
  'report.newpurchased.c02.lbl03': `实际`,
  'report.newpurchased.c02.lbl04': `实际平均`,
  'report.newpurchased.c02.lbl05': `去年同期`,
  'report.newpurchased.n03.lbl01': `1`,
  'report.newpurchased.n03.txt02': `该报表显示各直销门店的YTD预测值、实际值、达成率 、MTD预测值、实际值、达成率及各个周的预测值和实际值`,
  'report.newpurchased.n03.lbl03': `2`,
  'report.newpurchased.n03.txt04': `预测值计算逻辑：预测新增购买会员人数 = 预估销售双数 * 新会员购买双数占比 / 新会员鞋类客单件 / 新会员鞋类购买频次。当门店的预测值为0时，预测值设为实际值。`,
  'report.newpurchased.n04.lbl01': `YTD未达标`,
  'report.newpurchased.n04.lbl02': `YTD达标`,
  'report.newpurchased.n04.rdo03': `地区`,
  'report.newpurchased.c03.rdo01': `门店`,
  'report.newpurchased.c03.lbl02': `YTD预测`,
  'report.newpurchased.c03.lbl03': `YTD实际`,
  'report.newpurchased.c03.lbl04': `YTD完成率`,
  'report.newpurchased.c03.lbl05': `MTD预测`,
  'report.newpurchased.c03.lbl06': `MTD实际`,
  'report.newpurchased.c03.lbl07': `MTD完成率`,
  'report.newpurchased.c03.lbl08': `W预测`,
  'report.newpurchased.c03.lbl09': `W实际`,
  'report.newpurchased.c03.lbl10': `总计`,
  'report.newpurchased.c03.lbl11': `请输入需查询的门店`,
  'report.newpurchased.c03.lbl12': `实际新增购买会员人数=2019年起注册且今年首购的会员数`,
  'report.newpurchased.n02.tip07': `预测新增购买会员人数=预估销售双数*新会员购买双数占比/新会员鞋类客单件/新会员鞋类购买频次`,
  'report.newpurchased.n02.tip08': `实际新增购买会员人数本月首购的会员数`,
  'report.health.n01.lbl01': `该报表的更新周期为T+1，次日可查到昨日及更久之前的结果`,
  'report.health.n02.rdo01': `统计月份`,
  'report.health.n02.rdo02': `周期`,
  'report.health.n02.rdo03': `渠道`,
  'report.health.n02.rdo04': `子渠道`,
  'report.health.n03.lbl01': `总销售额`,
  'report.health.n03.tip02': `产品大类为鞋和配件的购买金额`,
  'report.health.n03.tip03': `当数值整数部分大于3位数时，用K,M,B缩小方式显示，`,
  'report.health.n03.lbl04': `同比`,
  'report.health.n03.tip05': `（当年数值-去年数值）/去年数值。特殊约定`,
  'report.health.n03.lbl06': `票数`,
  'report.health.n03.tip07': `产品大类为鞋的件数`,
  'report.health.n03.lbl08': `同比`,
  'report.health.n03.lbl09': `新会员`,
  'report.health.n03.lbl10': `老会员`,
  'report.health.n03.lbl11': `非会员`,
  'report.health.n03.tip12': `销售额占比`,
  'report.health.n03.tip13': `按12个月展示销售额的趋势`,
  'report.health.n04.lbl01': `总购买会员数`,
  'report.health.n04.tip02': `在统计范围内，总购买金额大于0的会员数`,
  'report.health.n04.lbl03': `同比`,
  'report.health.n04.lbl04': `票数`,
  'report.health.n04.tip05': `产品大类为鞋的件数`,
  'report.health.n04.lbl06': `同比`,
  'report.health.n04.lbl07': `新会员`,
  'report.health.n04.lbl08': `老会员`,
  'report.health.n04.tip09': `会员人数占比`,
  'report.health.n04.lbl10': `新会员`,
  'report.health.n04.tip11': `根据会员注册时间，在统计时间内注册的为新会员`,
  'report.health.n04.lbl12': `总购买会员数`,
  'report.health.n04.tip13': `根据会员注册时间，在统计时间内注册的会员总数`,
  'report.health.n04.lbl14': `会员销售金额`,
  'report.health.n04.tip15': `根据会员注册时间，在统计时间内注册的会员的购买金额`,
  'report.health.n04.lbl16': `老会员`,
  'report.health.n04.tip17': `根据会员注册时间，在统计时间之前注册的为老会员`,
  'report.health.n04.lbl18': `总购买会员数`,
  'report.health.n04.tip19': `根据会员注册时间，在统计时间之前注册的会员总数`,
  'report.health.n04.lbl20': `会员销售金额`,
  'report.health.n04.tip21': `根据会员注册时间，在统计时间之前注册的会员的购买金额`,
  'report.health.n05.lbl01': `指标趋势`,
  'report.health.n05.lbl02': `会员数`,
  'report.health.n05.tip03': `在统计范围最大时间之前的所有会员数，统计范围内注册的为新用户，统计范围之前的为老用户`,
  'report.health.n05.lbl04': `新招募会员数`,
  'report.health.n05.tip05': `统计范围内注册的会员数，只有新会员`,
  'report.health.n05.lbl06': `人均购买金额`,
  'report.health.n05.tip07': `新会员：新会员购买金额总和 / 有购买会员总数`,
  'report.health.n05.tip08': `老会员：老会员购买金额总和 / 有购买会员总数`,
  'report.health.n05.lbl09': `复购率`,
  'report.health.n05.tip10': `按照月份计算，统计范围R12月`,
  'report.health.n05.tip11': `新会员：R12月内新会员购买次数>1 / R12月内注册新会员购买次数>0`,
  'report.health.n05.tip12': `老会员：R12月内老会员购买次数>1 / R12月内老会员购买次数>0`,
  'report.health.n05.lbl13': `客单价`,
  'report.health.n05.tip14': `新会员：新会员购买金额 / 新会员购买订单数`,
  'report.health.n05.tip15': `老会员：老会员购买金额 / 老会员购买订单数`,
  'report.health.n05.lbl16': `留存率`,
  'report.health.n05.tip17': `按照月份计算，统计范围R12月，（只有老会员有数值）`,
  'report.health.n05.tip18': `老会员：会员在本期R12和上期R12均是购买会员的会员数 / 上期R12有购买的会员数`,
  'report.health.n05.lbl19': `会员贡献率`,
  'report.health.n05.tip20': `新会员：新会员购买金额总和 / 当月总的购买金额(包含非会员)`,
  'report.health.n05.tip21': `老会员：老会员购买金额总和 / 当月总的购买金额(包含非会员)`,
  'report.health.n05.lbl22': `客单件`,
  'report.health.n05.tip23': `新会员：新会员购买双数 / 新会员购买订单数`,
  'report.health.n05.tip24': `老会员：老会员购买双数 / 老会员购买订单数`,
  'report.health.n05.lbl25': `TY：2021  LY：2019`,
  'report.health.n05.tip26': `趋势图展示的TY和LY对应的年份数`,
  'report.health.n05.lbl27': `TY 新会员`,
  'report.health.n05.lbl28': `TY 老会员`,
  'report.health.n05.lbl29': `LY 新会员`,
  'report.health.n05.lbl30': `LY 老会员`,
  'report.health.n06.lbl01': `剧目销售Top10`,
  'report.health.n06.lbl02': `销售数量`,
  'report.health.n06.lbl03': `余票数量`,
  'report.health.n06.lbl04': `销售额`,
  'report.health.n06.lbl05': `卖座率`,
  'report.health.n06.lbl06': `剧目编号：`,
  'report.health.n06.tip01': `销售数量：该剧目统计周期内支付成功的出票数量合计`,
  'report.health.n06.tip02': `余票数量：统计时点该剧目剩余可售票数`,
  'report.health.n06.tip03': `销售额：该剧目统计周期内支付成功订单的实付金额合计`,
  'report.health.n06.tip04': `卖座率：销售数量 ÷总票数（销售数量 + 余票数量）`,
  'report.health.n06.tip05': `文广：票池已售/总数`,
  'report.health.n06.tip06': `非文广：只展示台上见卖的/总数`,
};

export const report_enUS = {
  'report.retail.c01.lbl01': `VIP CARD ID.`,
  'report.retail.c01.lbl02': `GENDER`,
  'report.retail.c01.lbl03': `AGE`,
  'report.retail.c01.lbl04': `RANK`,
  'report.retail.c01.lbl05': `GRAND TOTAL POINTS`,
  'report.retail.c01.lbl06': `GRAND TOTAL CONSUME`,
  'report.retail.c01.lbl07': `STORE OF CARD ACTIVATED`,
  'report.retail.c01.lbl08': `STORE OF CONSUMING`,
  'report.retail.c01.lbl09': `BEGINNING DATE`,
  'report.retail.c01.lbl10': `ACTION`,
  'report.retail.detail.n01.lbl01': `BASIC INFORMATION`,
  'report.retail.detail.n01.lbl02': `VIP CARD ID.`,
  'report.retail.detail.n01.lbl03': `GENDER`,
  'report.retail.detail.n01.lbl04': `AGE`,
  'report.retail.detail.n01.lbl05': `RANK`,
  'report.retail.detail.n01.lbl06': `GRAND TOTAL POINTS`,
  'report.retail.detail.n01.lbl07': `GRAND TOTAL CONSUME`,
  'report.retail.detail.n01.lbl08': `STORE OF CARD ACTIVATED`,
  'report.retail.detail.n01.lbl09': `STORE OF CONSUMING`,
  'report.retail.detail.n01.lbl10': `BEGINNING DATE`,
  'report.retail.detail.n01.lbl11': `BIRTHDAY`,
  'report.retail.detail.n01.lbl12': `VAILD`,
  'report.retail.detail.n01.lbl13': `DATE OF CARD ACTIVATED`,
  'report.retail.detail.n02.lbl01': `MEMBER DETAIL`,
  'report.retail.detail.n02.lbl02': `ORDER RECORDS`,
  'report.retail.detail.n02.lbl03': `EXCHANGE RECORDS`,
  'report.retail.detail.n02.lbl04': `DAOGOUTONG LABEL`,
  'report.retail.detail.c01.lbl01': `TYPE`,
  'report.retail.detail.c01.lbl02': `SERIAL NUMBER`,
  'report.retail.detail.c01.lbl03': `YEAR`,
  'report.retail.detail.c01.lbl04': `MONTH`,
  'report.retail.detail.c01.lbl05': `DAY`,
  'report.retail.detail.c01.lbl06': `SUBSCRIBE`,
  'report.retail.detail.c01.lbl07': `SEASON IN PRC`,
  'report.retail.detail.c01.lbl08': `CLASS`,
  'report.retail.detail.c01.lbl09': `ITEM GENDER `,
  'report.retail.detail.c01.lbl10': `SHAPE`,
  'report.retail.detail.c01.lbl11': `NAME`,
  'report.retail.detail.c01.lbl12': ` `,
  'report.retail.detail.c01.lbl13': ` `,
  'report.retail.detail.c01.lbl14': ` `,
  'report.retail.detail.c01.lbl15': ` `,
  'report.retail.detail.c01.lbl16': ` `,
  'report.retail.detail.c01.lbl17': ` `,
  'report.retail.detail.c01.lbl18': ` `,
  'report.retail.detail.c02.lbl01': `DATE`,
  'report.retail.detail.c02.lbl02': `POINTS CONSUMED`,
  'report.retail.detail.c02.lbl03': `EXCHANGE FOR`,
  'report.newpurchased.n01.lbl01': `LASTEST DATA TIME`,
  'report.newpurchased.n02.lbl01': `1`,
  'report.newpurchased.n02.txt01': `THE REPORT REVEALS NEW PURCHASED MEMBERS INDICATORS UP TO YESTERDAY BY MARKETING.`,
  'report.newpurchased.n02.txt02': `ACHIEVEMENT RATE EQUALS NEW PURCHASED MEMBERS DIVIDED BY INDICATORS.IT EQUALS 0 ESPECIALLY WHEN INDICATOR SET TO 0.`,
  'report.newpurchased.n02.lbl03': `2`,
  'report.newpurchased.n02.txt04': `WEEK EQUALS BETWEEN IT IN OUTLOOK,WEEKLY STATISTICS PREDICTION AND ACTUAL TREND.IT EQUALS 0 ESPECIALLY LAST WEEK BELONGS TO LAST YEAR.`,
  'report.newpurchased.n02.lbl05': `3`,
  'report.newpurchased.n02.txt06': `HOVER THE ! IN REPORT FOR DEFINITIONS`,
  'report.newpurchased.c01.lbl01': `MARKETING`,
  'report.newpurchased.c01.lbl02': `INDICATION`,
  'report.newpurchased.c01.lbl03': `NUMBER OF MEMBERS`,
  'report.newpurchased.c01.tip04': `Registrated after 2019 but never purchased before this year`,
  'report.newpurchased.c01.lbl05': `ACHIEVEMENT RATE`,
  'report.newpurchased.c01.tip06': `Equals new purchased members divided by indicators.It equals 0 especially when indicator is 0.`,
  'report.newpurchased.c02.lbl01': `WEEKLY STATISTICS PREDICTION AND ACTUAL TREND`,
  'report.newpurchased.c02.lbl02': `PREDICTED`,
  'report.newpurchased.c02.lbl03': `ACTUAL`,
  'report.newpurchased.c02.lbl04': `AVERAGE`,
  'report.newpurchased.c02.lbl05': `SAME TIME LAST YEAR`,
  'report.newpurchased.n03.lbl01': `1`,
  'report.newpurchased.n03.txt02': `THIS REPORT REVEALS YTD/MTD/WEEKLY PREDICTED VALUE,YTD/MTD/WEEKLY ACTUAL VALUE AND YTD/MTD ACHIEVEMENT RATE.`,
  'report.newpurchased.n03.lbl03': `2`,
  'report.newpurchased.n03.txt04': `PREDICTED VALUE:PREDICTED NEW PURCHASED MEMBERS EQUALS PREDICTED SELLED PAIRS * PAIRS NEW MEMBERS PURCHASED /AVERAGE PAIRS PER ORDER / FREQUENCY NEW MEMBERS PURCHASED.IT EQUALS 0 ESPECIALLY WHEN PREDICTED VALUE SET TO 0.`,
  'report.newpurchased.n04.lbl01': `YTD REACH THE STANDARD`,
  'report.newpurchased.n04.lbl02': `YTD NOT REACH THE STANDARD`,
  'report.newpurchased.n04.rdo03': `REGION`,
  'report.newpurchased.c03.rdo01': `STORE`,
  'report.newpurchased.c03.lbl02': `YTD PREDICTED`,
  'report.newpurchased.c03.lbl03': `YTD ACTUAL`,
  'report.newpurchased.c03.lbl04': `YTD A-RATE`,
  'report.newpurchased.c03.lbl05': `MTD PREDICTED`,
  'report.newpurchased.c03.lbl06': `MTD ACTUAL`,
  'report.newpurchased.c03.lbl07': `MTD A-RATE`,
  'report.newpurchased.c03.lbl08': `WEEK X PREDICTED`,
  'report.newpurchased.c03.lbl09': `WEEK X ACTUAL`,
  'report.newpurchased.c03.lbl10': `TOTAL`, //总计
  'report.newpurchased.c03.lbl11': `PLEASE ENTER THE STORE YOU WANT TO QUERY`, //请输入需查询的门店
  'report.newpurchased.c03.lbl12': `THE ACTUAL NUMBER OF NEWLY PURCHASED MEMBERS = THE NUMBER OF MEMBERS WHO HAVE REGISTERED SINCE 2019 AND PURCHASED FIRST THIS YEAR`, //实际新增购买会员人数=2019年起注册且今年首购的会员数
  'report.newpurchased.n02.tip07': `Forecast number of newly purchased members = estimated number of sales * proportion of new members to buy even numbers/single piece of new member shoes/frequency of new member shoes purchase`,
  'report.newpurchased.n02.tip08': `Actual number of new members purchased Number of members who first purchased this month`,
  'report.health.n01.lbl01': `THIS PAGE REFRESHES BY MONTH.DATA OF LAST OR PREVIOUS MONTH CAN BE SEARCHED AFTER 1ST OF EVERY MONTH.`,
  'report.health.n02.rdo01': `MONTH`,
  'report.health.n02.rdo02': `CYCLE`,
  'report.health.n02.rdo03': `SOURCE`,
  'report.health.n02.rdo04': `SUB-SOURCE`,
  'report.health.n03.lbl01': `ALL VALUES`,
  'report.health.n03.tip02': `Values of items belongs to Shoes and Accessories`,
  'report.health.n03.tip03': `Show abbreviated format with K,M,B when integer part larger than 1000.: K=1,000.M=1,000,000.B=1,000,000,000.Round up to 2 decimal places`,
  'report.health.n03.lbl04': `YEAR-ON-YEAR`,
  'report.health.n03.tip05': `(TY-LY)/LY.: LY=2019 especially when TY=2021.`,
  'report.health.n03.lbl06': `PAIRS`,
  'report.health.n03.tip07': `Items belong to pairs of shoes`,
  'report.health.n03.lbl08': `YEAR-ON-YEAR`,
  'report.health.n03.lbl09': `NEW MEMBER`,
  'report.health.n03.lbl10': `OLD MEMBER`,
  'report.health.n03.lbl11': `NON MEMBER`,
  'report.health.n03.tip12': `Values Percentage`,
  'report.health.n03.tip13': `Trend`,
  'report.health.n04.lbl01': `MEMBERS PURCHASED`,
  'report.health.n04.tip02': `Members cousume more than 0 in counting period.`,
  'report.health.n04.lbl03': `YEAR-ON-YEAR`,
  'report.health.n04.lbl04': `PAIRS`,
  'report.health.n04.tip05': `Items belong to pairs of shoes`,
  'report.health.n04.lbl06': `YEAR-ON-YEAR`,
  'report.health.n04.lbl07': `NEW MEMBER`,
  'report.health.n04.lbl08': ``,
  'report.health.n04.tip09': `Percentage of members`,
  'report.health.n04.lbl10': `NEW MEMBER`,
  'report.health.n04.tip11': `Members registrated in counting period`,
  'report.health.n04.lbl12': `MEMBERS PURCHASED`,
  'report.health.n04.tip13': `Amount of members registrated in counting period`,
  'report.health.n04.lbl14': `VALUES MEMBERS PURCHASED`,
  'report.health.n04.tip15': `Amount of purchase by members registrated in counting period`,
  'report.health.n04.lbl16': `OLD MEMBER`,
  'report.health.n04.tip17': `Members registrated before counting period`,
  'report.health.n04.lbl18': `MEMBERS PURCHASED`,
  'report.health.n04.tip19': `Amount of members registrated before counting period`,
  'report.health.n04.lbl20': `VALUES MEMBERS PURCHASED`,
  'report.health.n04.tip21': `Amount of purchase by members registrated before counting period`,
  'report.health.n05.lbl01': `INDICATOR TREND`,
  'report.health.n05.lbl02': `AMOUNT OF MEMBERS`,
  'report.health.n05.tip03': `Amount of members registrated before counting period ends.Which before is old while in is new.`,
  'report.health.n05.lbl04': `AMOUNT OF NEW MEMBERS`,
  'report.health.n05.tip05': `New members in counting period`,
  'report.health.n05.lbl06': `AVERAGE PRICE VALUE`,
  'report.health.n05.tip07': `New members: Values of new members purchased/Amount of purchased members.`,
  'report.health.n05.tip08': `Old members: Values of old members purchased/Amount of purchased members.`,
  'report.health.n05.lbl09': `BUYER RETENTION`,
  'report.health.n05.tip10': `Calculated according to month.Statisticing in R12 months.`,
  'report.health.n05.tip11': `New Members: New members purchased in R12 more than 1 time/New members purchased in R12 more than 0 time.`,
  'report.health.n05.tip12': `Old Members: Old members purchased in R12 more than 1 time/old members purchased in R12 more than 0 time.`,
  'report.health.n05.lbl13': `AVERAGE TRANSACTION VALUE`,
  'report.health.n05.tip14': `New Members: Values of new members purchased/Orders of new members purchased.`,
  'report.health.n05.tip15': `Old Members: Values of old members purchased/Orders of old members purchased.`,
  'report.health.n05.lbl16': `RETENTION RATES`,
  'report.health.n05.tip17': `Calculated according to month.`,
  'report.health.n05.tip18': `Old members: Member who both purchased in this and last R12/Member only purchased in last R12`,
  'report.health.n05.lbl19': `PERCENTAGE OF MEMBERS PURCHASED`,
  'report.health.n05.tip20': `New Members: Values of new members purchased/Values of month(inclued non-members).`,
  'report.health.n05.tip21': `Old Members: Values of old members purchased/Values of month(inclued non-members).`,
  'report.health.n05.lbl22': `AVERAGE PAIRS PER ORDER`,
  'report.health.n05.tip23': `New Members: Pairs of new members purchased/Orders of new members purchased.`,
  'report.health.n05.tip24': `Old Members: Pairs of old member purchased/Orders of old members purchased.`,
  'report.health.n05.lbl25': `TY：2021  LY：2019`,
  'report.health.n05.tip26': `Diagram reveals years which TY and LY specifies`,
  'report.health.n05.lbl27': `TY NEW`,
  'report.health.n05.lbl28': `TY OLD`,
  'report.health.n05.lbl29': `LY NEW`,
  'report.health.n05.lbl30': `LY OLD`,
  'report.health.n06.lbl01': ` `, //当季主推款
  'report.health.n06.lbl02': ` `, //销售数量
  'report.health.n06.lbl03': ` `, //余票数量
  'report.health.n06.lbl04': ` `, //销售额
  'report.health.n06.lbl05': ` `, //卖座率
  'report.health.n06.lbl06': ` `, //剧目编号：
  'report.health.n06.tip01': ` `, //该剧目统计周期内支付成功的出票数量合计
  'report.health.n06.tip02': ` `, //统计时点该剧目剩余可售票数
  'report.health.n06.tip03': ` `, //该剧目统计周期内支付成功订单的实付金额合计
  'report.health.n06.tip04': ` `, //销售数量 ÷总票数（销售数量 + 余票数量）
};
